import { Label, Input } from "@educrib/firefly";
import FieldGroup from "./FieldGroup";

export default function Icon({ label = true }: { label?: Boolean }) {
  return (
    <FieldGroup>
      {label && <Label>Icon</Label>}
      <Input type="text" name="icon" placeholder="Icon" />
    </FieldGroup>
  );
}
